// Figma: https://www.figma.com/design/iYlbYhvyJjh7X00UAcqCWt/About-page?node-id=13-1100
import { Flex, Image, Text } from "@chakra-ui/react";
import { aboutAsset } from "../aboutAssets";

const squiggle = aboutAsset("squiggle-1.svg");

interface SectionHeadingProps {
  title: string;
  align?: "center" | "flex-start";
}

export function SectionHeading({ title, align = "center" }: SectionHeadingProps) {
  return (
    <Flex direction="column" align={align} gap="16px">
      <Text
        fontSize="40px"
        fontWeight="600"
        color="dune.dune"
        fontFamily="'Bricolage Grotesque', sans-serif"
        lineHeight="1.2"
        textAlign={align === "center" ? "center" : "left"}
      >
        {title}
      </Text>
      <Image src={squiggle} alt="" w="186px" h="12px" />
    </Flex>
  );
}
